import React from 'react';

import { Box } from '@mui/material';

import qvLogo from "../../../../resources/qv_logo.svg";
import edulendoLogo from "../../../../resources/edulendo_logo.svg";
import ShopConfig from '../../../api/config/shopConfig';

import { useSelector } from 'react-redux';
import { selectBrand, selectOrganisationLogo } from '../../../store/settingsSlice';

const brandLogos = {
    edulendo: edulendoLogo,
    quickverleih: qvLogo,
};

export default function Logo(props) {
    const {position = "absolute", sx = {}} = props;
    const brand = useSelector(selectBrand);
    const organisationLogo = useSelector(selectOrganisationLogo);
    const brandLogo = brandLogos[brand] || qvLogo;

    return (
        <>
        { organisationLogo === "" ?
            <Box
                component="img"
                sx={{
                    mr: 3,
                    width: 170,
                    maxWidth: { xs: 100, md: 130 },
                    position: position,
                    ...sx
                }}
                alt={brand === "edulendo" ? "Edulendo Logo" : "Quickverleih Logo"}
                src={brandLogo}
            /> :
            <Box
                component="img"
                alt="OrganisationLogo"
                src={ShopConfig.config().getURLFor(organisationLogo)}
                sx={{ maxHeight: (theme) => theme.mixins.toolbar.minHeight * 0.95, objectFit: "contain", maxWidth: { xs: 150, sm: 200, md: 250 }, pl: 1, ...sx }}
            />

        }
        </>
    );
}
